<template>
    <ul>
        <li v-for="item in strArray" :key="item.url">
            <p>
                {{ $t(item.text) }}:
                <template v-if="item.key === 'url'">
                    <span v-show="typeWay === 'unknown' || typeWay === 'unbind'">{{ rowData.scopeName }}</span>
                    <span v-show="typeWay === 'bind' || typeWay === 'stop'">{{ rowData.scopeName }}-{{ rowData.sceneName
                    }}-{{ rowData.carrierName }}</span>
                </template>
                <span v-else-if="!item.isFunc">{{ rowData[item.key] }}</span>
                <span v-else>{{ FuncFn(item.key, rowData[item.key]) }}</span>
            </p>
        </li>
    </ul>
</template>

<script>

export default {
    props: ['rowData', 'typeWay'],
    data() {
        return {
            strArray: [
                {
                    text: 'public.belong',
                    key: 'url'
                },
                {
                    text: 'public.carrier',
                    key: 'carrierName'
                },
                {
                    text: 'device.gateway_name',
                    key: 'name'
                },
                {
                    text: 'device.gateway_mac',
                    key: 'mac'
                },
                {
                    text: 'device.gateway_type',
                    key: 'type',
                    isFunc: true
                },
                {
                    text: 'device.gateway_status',
                    key: 'status',
                    isFunc: true
                },
                {
                    text: 'device.config_status',
                    key: 'configStatus',
                    isFunc: true
                },
                {
                    text: 'public.table_create_time',
                    key: 'createTime',
                    isFunc: true
                },
                {
                    text: $t('integration.gateway_deactivation_time'),
                    key: 'updateTime',
                    isFunc: true
                },
            ],
        }
    },
    mounted() {
        if (this.typeWay === 'stop') {
            this.strArray.splice(1, 1);
            this.strArray.splice(4, 3);
        }
        if (this.typeWay === 'bind' || this.typeWay === 'unbind') {
            this.strArray.pop();
        }
        if (this.typeWay === 'unbind') {
            this.strArray.splice(1, 1);
        }
        if (this.typeWay === 'unknown') {
            this.strArray = [
                {
                    text: 'public.belong',
                    key: 'url'
                },
                {
                    text: 'device.gateway_name',
                    key: 'name'
                },
                {
                    text: 'device.gateway_mac',
                    key: 'mac'
                },
                {
                    text: 'device.gateway_type',
                    key: 'type',
                    isFunc: true
                },
                {
                    text: 'public.table_create_time',
                    key: 'createTime',
                    isFunc: true
                }
            ]
        }
    },
    methods: {
        FuncFn(key, value) {
            switch (key) {
                case 'type':
                    {
                        return value === 1 ? $t('deviceType.gt_1') : $t('deviceType.gt_2')
                    }
                case 'status':
                    {
                        return value === 1 ? this.$t('public.online') : this.$t('public.offline')
                    }
                case 'configStatus':
                    {
                        return value === 0 ? $t('device.wait_config') : (value === 1 ? $t('device.configured') : $t('device.configured'))
                    }
                case 'createTime':
                    {
                        return this.$timetransition(value)
                    }
                case 'updateTime':
                    {
                        return this.$timetransition(value)
                    }
                default:
                    break;
            }
        }
    }
}
</script>

<style>
</style>